export const environment = {
  production: true,
  buildId: '3035836768620031',
  configFile: 'config.json',
};
